module.exports = __webpack_public_path__ + "img/KIA.8ed68f18.png";